import AvatarDefaultIcon from '@assets/images/avatar/default.png';
import { useTenantAuth } from '@src/context/auth/useTenantAuth';
import { TENANT_URL } from '@src/routes/tenant';
import UserGuideLink from '@src/ui/elements/button/UserGuideLink';
import React from 'react';
import { Link } from 'react-router-dom';

interface TenantMobileUserNavigationMenuProps {
  isOpen: boolean;
  onClose: () => void;
  vw?: number;
}

const TenantMobileUserNavigationMenu: React.FC<TenantMobileUserNavigationMenuProps> = ({
  isOpen,
  onClose,
  vw,
}) => {
  const { profile } = useTenantAuth();

  if (!isOpen) {
    return null;
  }

  return (
    <div
      className='fixed inset-0 z-[10000] flex touch-pan-y flex-col overflow-y-auto overscroll-none bg-primary-800 text-white'
      style={{ width: vw ? `${vw}px` : undefined, maxWidth: vw ? `${vw}px` : undefined }}
    >
      <div className='flex h-[60px] items-center justify-end border-b border-gray-400 px-4'>
        <button
          type='button'
          className='grid size-6 place-items-center'
          onClick={onClose}
          aria-label='メニューを閉じる'
        >
          <div className='relative size-4'>
            <span className='absolute left-0 top-1/2 h-[2px] w-4 -translate-y-1/2 rotate-45 bg-white' />
            <span className='absolute left-0 top-1/2 h-[2px] w-4 -translate-y-1/2 -rotate-45 bg-white' />
          </div>
        </button>
      </div>
      <nav className='flex h-full flex-col px-6 py-5'>
        <div className='mt-5 flex flex-col gap-[20px]'>
          <div className='flex items-center gap-4 px-3'>
            <img
              className='size-6 rounded-full object-cover'
              src={profile?.user?.avatarUrl || AvatarDefaultIcon}
              alt='アバター'
              width='24'
              height='24'
            />
            <p className='grow truncate'>
              <span className='block truncate text-sm'>
                {`${profile?.user?.familyName || ''} ${profile?.user?.firstName || ''}`}
              </span>
            </p>
          </div>
          <div className='flex flex-col gap-px'>
            <Link
              to={TENANT_URL.PROFILE}
              className='px-3 py-[20px] transition-colors'
              onClick={onClose}
            >
              マイプロフィール
            </Link>
            <Link
              to={TENANT_URL.LOGOUT}
              className='mt-7 flex w-full items-center justify-center gap-[2px] rounded-[4px] border border-white py-[12px]'
              style={{ width: vw ? `${Math.max(vw - 50, 200)}px` : undefined }}
              onClick={onClose}
            >
              ログアウト
            </Link>
          </div>
        </div>
        <UserGuideLink
          userType='tenant'
          device='mobile'
          color='white'
        />
      </nav>
    </div>
  );
};

export default TenantMobileUserNavigationMenu;
